import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Search as SearchIcon } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { CommunityCard, EventCard, ChallengeCard, ListingCard, PersonCard } from "@/components/cards";
import { Loader, EmptyState, SectionHeader } from "@/components/ui-bits";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); api.get(`/search?q=${encodeURIComponent(q)}`).then((r) => setData(r.data)); }, [q]);

  if (!data) return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"><Loader /></div>;
  const total = ["communities", "events", "challenges", "listings", "people", "passions"].reduce((n, k) => n + (data[k]?.length || 0), 0);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-10 space-y-10">
      <div><p className="text-xs font-semibold uppercase tracking-wider text-[#55708F] mb-1">Search results</p><h1 className="text-3xl font-extrabold tracking-tight">"{q}"</h1><p className="text-[#071126]/55 mt-1">{total} results</p></div>

      {total === 0 && <EmptyState icon={SearchIcon} title="No results found" hint="Try a different keyword — a passion, community, event or person." />}

      {data.passions?.length > 0 && (
        <section><SectionHeader title="Passions" />
          <div className="grid gap-4 sm:grid-cols-3">{data.passions.map((p) => (
            <Link key={p.slug} to={`/passions/${p.slug}`} className="pa-card pa-card-hover overflow-hidden flex items-center gap-3 p-3"><img src={fileUrl(p.cover)} alt="" className="h-14 w-14 rounded-xl object-cover" /><span className="font-semibold text-[#071126]">{p.title}</span></Link>
          ))}</div>
        </section>
      )}
      {data.communities?.length > 0 && <section><SectionHeader title="Communities" /><div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{data.communities.map((c) => <CommunityCard key={c.id} c={c} />)}</div></section>}
      {data.events?.length > 0 && <section><SectionHeader title="Events" /><div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{data.events.map((e) => <EventCard key={e.id} e={e} />)}</div></section>}
      {data.challenges?.length > 0 && <section><SectionHeader title="Challenges" /><div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">{data.challenges.map((c) => <ChallengeCard key={c.id} c={c} />)}</div></section>}
      {data.listings?.length > 0 && <section><SectionHeader title="Marketplace" /><div className="grid gap-5 grid-cols-2 lg:grid-cols-4">{data.listings.map((l) => <ListingCard key={l.id} l={l} />)}</div></section>}
      {data.people?.length > 0 && <section><SectionHeader title="People" /><div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{data.people.map((p) => <PersonCard key={p.id} p={p} />)}</div></section>}
    </div>
  );
}
